import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section
      id="manifesto"
      className="relative py-32 md:py-48 px-6 md:px-12 bg-[#050505]"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="flex items-center gap-4 mb-16">
          <span className="inline-block w-8 h-px bg-[color:var(--accent)]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[color:var(--muted)]">
            {t.manifesto.label}
          </span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-display uppercase text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[0.9] tracking-[-0.03em] whitespace-pre-line max-w-6xl"
        >
          {t.manifesto.title}
        </motion.h2>

        <div className="mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-12 gap-y-24 md:gap-x-16">
          {t.manifesto.chapters.map((ch, i) => (
            <motion.article
              key={ch.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={
                i % 4 === 0
                  ? "md:col-span-6 md:col-start-1"
                  : i % 4 === 1
                  ? "md:col-span-5 md:col-start-8"
                  : i % 4 === 2
                  ? "md:col-span-5 md:col-start-2"
                  : "md:col-span-6 md:col-start-7"
              }
              data-testid={`manifesto-chapter-${ch.n}`}
            >
              <div className="flex items-baseline gap-6 mb-6">
                <span className="text-outline-accent font-display font-extrabold text-6xl md:text-8xl leading-none">
                  {ch.n}
                </span>
                <span className="h-px flex-1 bg-[color:var(--border)]" />
              </div>
              <h3 className="font-display text-3xl md:text-4xl font-bold tracking-[-0.02em] mb-6 leading-tight">
                {ch.title}
              </h3>
              <p className="text-base md:text-lg text-[color:var(--muted)] leading-relaxed max-w-md">
                {ch.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
